import React from 'react';
import PlusComponent from "../../myComp/PlusComponent";
import ContentSettings from "../../myComp/ContentSettings";

class ManualGet extends PlusComponent {
  constructor(props) {
    super(props, "contentManual");         
  }

  render(){     
    return (
        <div>
          <ContentSettings {...this.props} controller="contentManual"></ContentSettings>
        </div>
      )
    }
}

export default ManualGet;